export const SET_DOWNLOAD_XOSC_FILE_REQUEST = 'SET_DOWNLOAD_XOSC_FILE_REQUEST';
export const SET_DOWNLOAD_XOSC_FILE_SUCCESS = 'SET_DOWNLOAD_XOSC_FILE_SUCCESS';
export const SET_DOWNLOAD_XOSC_FILE_ERROR = 'SET_DOWNLOAD_XOSC_FILE_ERROR';
export const SET_DOWNLOAD_XOSC_FILE_RESET = 'SET_DOWNLOAD_XOSC_FILE_RESET';


export const SET_DOWNLOAD_GROUND_TRUTH_FILE_REQUEST = 'SET_DOWNLOAD_GROUND_TRUTH_FILE_REQUEST';
export const SET_DOWNLOAD_GROUND_TRUTH_FILE_SUCCESS = 'SET_DOWNLOAD_GROUND_TRUTH_FILE_SUCCESS';
export const SET_DOWNLOAD_GROUND_TRUTH_FILE_ERROR = 'SET_DOWNLOAD_GROUND_TRUTH_FILE_ERROR';
export const SET_DOWNLOAD_GROUND_TRUTH_FILE_RESET = 'SET_DOWNLOAD_GROUND_TRUTH_FILE_RESET';


export const SET_AVAILABLE_KPI_LIST_REQUEST = 'SET_AVAILABLE_KPI_LIST_REQUEST';
export const SET_AVAILABLE_KPI_LIST_SUCCESS = 'SET_AVAILABLE_KPI_LIST_SUCCESS';
export const SET_AVAILABLE_KPI_LIST_ERROR = 'SET_AVAILABLE_KPI_LIST_ERROR';
export const SET_AVAILABLE_KPI_LIST_RESET = 'SET_AVAILABLE_KPI_LIST_RESET';
export const SET_ENABLE_SPECIFIC_KPI = 'SET_ENABLE_SPECIFIC_KPI';
export const SET_SELECT_ALL_AVAILABLE_KPI = 'SET_SELECT_ALL_AVAILABLE_KPI';
export const SET_DESELECT_ALL_AVAILABLE_KPI = 'SET_DESELECT_ALL_AVAILABLE_KPI';


export const SET_DOWNLOAD_KPI_FILES_REQUEST = 'SET_DOWNLOAD_KPI_FILES_REQUEST';
export const SET_DOWNLOAD_KPI_FILES_SUCCESS = 'SET_DOWNLOAD_KPI_FILES_SUCCESS';
export const SET_DOWNLOAD_KPI_FILES_ERROR = 'SET_DOWNLOAD_KPI_FILES_ERROR';
export const SET_DOWNLOAD_KPI_FILES_RESET = 'SET_DOWNLOAD_KPI_FILES_RESET';